const ContactSection = () => {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      body.append(key, value.toString());
    });
    try {
      await fetch('https://readdy.ai/api/form/d7dtmtem3fsfopf241kg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      form.reset();
      alert('Mensagem enviada! Retornaremos em breve.');
    } catch {
      alert('Erro ao enviar. Por favor tente novamente.');
    }
  };

  return (
    <section id="contato" className="py-20 md:py-28" style={{ background: '#F5ECD7', fontFamily: "'Sora', sans-serif" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-12 md:gap-16">
          {/* Info */}
          <div className="w-full lg:w-5/12">
            <span className="inline-block bg-[#878450]/15 text-[#710005] text-xs font-semibold px-3 py-1 rounded-full tracking-widest uppercase mb-5 border border-[#878450]/30">
              Fale Conosco
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#2C0000] leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Entre em Contato
            </h2>
            <p className="text-[#710005]/70 text-sm md:text-base leading-relaxed mb-10">
              Quer fazer um pedido ou tirar dúvidas? Estamos prontos para atender você pelos nossos canais de contato.
            </p>

            <div className="space-y-4">
              <a
                href="https://wa.me/message/DRV2SM3UW3BDK1"
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center gap-4 p-4 bg-white rounded-xl hover:bg-[#878450]/10 transition-colors cursor-pointer group border border-[#878450]/15"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-green-100 text-green-700">
                  <i className="ri-whatsapp-line text-xl"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-[#2C0000]">WhatsApp</p>
                  <p className="text-xs text-[#710005]/60">Resposta rápida · Faça seu pedido</p>
                </div>
                <i className="ri-arrow-right-line text-[#710005]/50 ml-auto group-hover:translate-x-1 transition-transform"></i>
              </a>
              <a
                href="https://www.facebook.com/guarnierimorangosevinhos/"
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center gap-4 p-4 bg-white rounded-xl hover:bg-[#878450]/10 transition-colors cursor-pointer group border border-[#878450]/15"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-[#e8f0fe] text-[#3b5998]">
                  <i className="ri-facebook-fill text-xl"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-[#2C0000]">Facebook</p>
                  <p className="text-xs text-[#710005]/60">Nos siga e envie uma mensagem</p>
                </div>
                <i className="ri-arrow-right-line text-[#710005]/50 ml-auto group-hover:translate-x-1 transition-transform"></i>
              </a>
              <a
                href="https://www.instagram.com/guarnieri_morangosevinhos/"
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center gap-4 p-4 bg-white rounded-xl hover:bg-[#878450]/10 transition-colors cursor-pointer group border border-[#878450]/15"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-pink-100 text-pink-600">
                  <i className="ri-instagram-line text-xl"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-[#2C0000]">Instagram</p>
                  <p className="text-xs text-[#710005]/60">@guarnieri_morangosevinhos</p>
                </div>
                <i className="ri-arrow-right-line text-[#710005]/50 ml-auto group-hover:translate-x-1 transition-transform"></i>
              </a>
              <a
                href="mailto:vinhosguarnieri.com@vinhosguarnieri.com"
                className="flex items-center gap-4 p-4 bg-white rounded-xl hover:bg-[#878450]/10 transition-colors cursor-pointer group border border-[#878450]/15"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-[#fef3e8] text-amber-700">
                  <i className="ri-mail-line text-xl"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-[#2C0000]">E-mail</p>
                  <p className="text-xs text-[#710005]/60">vinhosguarnieri.com@vinhosguarnieri.com</p>
                </div>
                <i className="ri-arrow-right-line text-[#710005]/50 ml-auto group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>
          </div>

          {/* Form */}
          <div className="w-full lg:w-7/12">
            <div className="bg-white rounded-2xl p-6 md:p-8 border border-[#878450]/15">
              <h3 className="text-lg font-bold text-[#2C0000] mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>Envie uma mensagem</h3>
              <form
                data-readdy-form
                id="contato-vinicola"
                onSubmit={handleSubmit}
                className="space-y-4"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-[#710005]/70 mb-1.5">Nome *</label>
                    <input
                      type="text"
                      name="nome"
                      required
                      placeholder="Seu nome completo"
                      className="w-full border border-[#878450]/25 rounded-lg px-4 py-3 text-sm text-[#2C0000] placeholder-[#878450]/50 focus:outline-none focus:border-[#710005] transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-[#710005]/70 mb-1.5">E-mail</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="seu@email.com"
                      className="w-full border border-[#878450]/25 rounded-lg px-4 py-3 text-sm text-[#2C0000] placeholder-[#878450]/50 focus:outline-none focus:border-[#710005] transition-colors"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-medium text-[#710005]/70 mb-1.5">Telefone / WhatsApp</label>
                  <input
                    type="tel"
                    name="telefone"
                    placeholder="(00) 00000-0000"
                    className="w-full border border-[#878450]/25 rounded-lg px-4 py-3 text-sm text-[#2C0000] placeholder-[#878450]/50 focus:outline-none focus:border-[#710005] transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-[#710005]/70 mb-1.5">Interesse</label>
                  <select
                    name="interesse"
                    className="w-full border border-[#878450]/25 rounded-lg px-4 py-3 text-sm text-[#2C0000] focus:outline-none focus:border-[#710005] transition-colors bg-white cursor-pointer"
                  >
                    <option value="">Selecione um produto</option>
                    <option value="Vinhos PET">Vinhos PET</option>
                    <option value="Vinagre Colonial">Vinagre Colonial</option>
                    <option value="Suco de Uva Integral">Suco de Uva Integral</option>
                    <option value="Todos os produtos">Todos os produtos</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-[#710005]/70 mb-1.5">Mensagem *</label>
                  <textarea
                    name="mensagem"
                    required
                    rows={4}
                    maxLength={500}
                    placeholder="Descreva seu pedido ou dúvida..."
                    className="w-full border border-[#878450]/25 rounded-lg px-4 py-3 text-sm text-[#2C0000] placeholder-[#878450]/50 focus:outline-none focus:border-[#710005] transition-colors resize-none"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full bg-[#710005] text-[#FCF1D7] py-4 rounded-lg font-semibold text-sm hover:bg-[#2C0000] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Enviar Mensagem
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
